import React from 'react';
import IndicadorEstado from '../../../../IndicadorEstado';

const Indicador = ({ ajuste, id, handleEstadoIndicador,  estado, index }) => {

  const handleClick = () => {
    handleEstadoIndicador(id, estado)
  }

  return ( 
    <div className="Indicador d-flex bg-light justify-content-between align-items-center p-3 mb-2">
      <span>{index+1}.- {ajuste}</span>
      <IndicadorEstado
        variant={`${estado === 'Completo' ? 'success' : 'danger'}`}
        handleClick={handleClick} 
      >
        {estado}
      </IndicadorEstado>
    </div>
   );
}
 
export default Indicador;